
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.28.747a1 1 0 011.44 0l.958.995a1 1 0 00.997.267l1.328-.382a1 1 0 011.247.72l.332 1.34a1 1 0 00.73.73l1.34.333a1 1 0 01.721 1.247l-.382 1.328a1 1 0 00.267.997l.995.958a1 1 0 010 1.44l-.995.958a1 1 0 00-.267.997l.382 1.328a1 1 0 01-.72 1.247l-1.34.332a1 1 0 00-.73.73l-.333 1.34a1 1 0 01-1.247.721l-1.328-.382a1 1 0 00-.997.267l-.958.995a1 1 0 01-1.44 0l-.958-.995a1 1 0 00-.997-.267l-1.328.382a1 1 0 01-1.247-.72l-.332-1.34a1 1 0 00-.73-.73l-1.34-.333a1 1 0 01-.721-1.247l.382-1.328a1 1 0 00-.267-.997l-.995-.958a1 1 0 010-1.44l.995-.958a1 1 0 00.267-.997l-.382-1.328a1 1 0 01.72-1.247l1.34-.332a1 1 0 00.73-.73l.333-1.34a1 1 0 011.247-.721l1.328.382a1 1 0 00.997-.267L9.28.747z","fill":"#218665"}}),_c('path',{attrs:{"d":"M5.556 10.556l2.777 2.777 6.111-6.11","stroke":"#fff","stroke-width":"2","stroke-linecap":"round"}})])
          )
        }
      }
    